import { getSiteAndPipelineCountMap, pipelineActions } from '@redux/slices/pipeline/pipeline-slice';
import { checkOldAndNewArray } from '@services/check-old-and-new-array';
import { getAppDispatch } from '@utilities/dispatch.util';
import { store } from 'redux/store';

const pipelineJsonManipulationJson = ({ initialLogin, data, isSettingUpdated }) => {
  const { items = [] } = data;
  const { pipeline } = store.getState();

  let resPipeline = [];
  if (!initialLogin && pipeline?.pipelineMobile?.length && !isSettingUpdated) {
    if (items?.length) {
      const combineNewAndOldArray = checkOldAndNewArray({
        oldArray: pipeline?.pipelineMobile,
        oldArrayMap: pipeline?.pipelineMobileMap || {},
        newArray: items,
        idName: 'pipelineId'
      });
      resPipeline = combineNewAndOldArray;
    } else {
      resPipeline = pipeline?.pipelineMobile;
    }
  } else {
    if (items?.length) resPipeline = items;
  }

  const pipelineMobile = resPipeline;
  const pipelineMobileMap = resPipeline.reduce((acc, curr, currIndex) => {
    acc[curr.pipelineId] = currIndex;
    return acc;
  }, {});

  const sitePipelineCountMap = getSiteAndPipelineCountMap({ pipelines: pipelineMobile });

  return {
    sitePipelineCountMap,
    pipelineMobileMap,
    pipelineMobile
  };
};

const pipelineDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(pipelineActions.setPipelineMobile(data));
};

export { pipelineJsonManipulationJson, pipelineDispatcher };
